import { Directive, ElementRef, Input, HostListener, Renderer2 } from "@angular/core"

@Directive({
    selector: "[sticky]",
})
export class StickyDirective {
    @Input() offset: number = 0
    isSticky: boolean = false
    originalWidth: number = null
    staticOffset: number = null
    bottomLimit: number = null

    @HostListener("window:load") onWindowLoad() {
        this.getInitialData()
    }

    @HostListener("window:scroll") onWindowScroll() {
        if (document.readyState === "complete") {
            this.staticOffset = document.getElementById("resultsWrapper").offsetTop // to be redfactored
            this.bottomLimit =
                document.getElementById("footer").offsetTop - this.el.nativeElement.clientHeight

            let scrollTop = window.pageYOffset || document.documentElement.scrollTop

            if (scrollTop > this.staticOffset && scrollTop < this.bottomLimit) {
                this.stick()
            } else if (scrollTop > this.staticOffset && scrollTop > this.bottomLimit) {
                this.stickToEnd()
            } else {
                this.unstick()
            }
        }
    }

    constructor(private el: ElementRef, private render: Renderer2) {}

    getInitialData() {
        this.originalWidth = this.el.nativeElement.clientWidth
        this.staticOffset = document.getElementById("resultsWrapper").offsetTop // to be redfactored
        this.bottomLimit =
            document.getElementById("footer").offsetTop - this.el.nativeElement.clientHeight
    }

    stickToEnd() {
        this.el.nativeElement.style.position = "absolute"
        this.el.nativeElement.style.top = "auto"
        this.el.nativeElement.style.bottom = "30px"
    }

    stick() {
        this.isSticky = true
        this.el.nativeElement.style.position = "fixed"
        this.el.nativeElement.style.zIndex = "999"
        this.el.nativeElement.style.width = `${this.originalWidth}px`
        this.el.nativeElement.style.maxWidth = "100%"
        this.el.nativeElement.style.top = `${this.offset}px`
        this.el.nativeElement.style.left = "auto"
        this.el.nativeElement.style.right = "auto"
        this.el.nativeElement.style.bottom = "auto"
        this.render.addClass(this.el.nativeElement, "sticky")
    }

    unstick() {
        this.isSticky = false
        this.el.nativeElement.style = ""
        this.render.removeClass(this.el.nativeElement, "sticky")
    }
}
